import { addBanner, addMasthead, addNative, addSkyscraper, addUnderstitial } from '../shared';
export const adSlots = [
    addSkyscraper({
        slotId: '/46859844/imn.de_SERP_Desktop_SkyscraperHPA',
        id: 'div-gpt-ad-1426592241524-0',
    }),
    addMasthead({
        slotId: '/46859844/imn.de_SERP_Desktop_Header_Billboard',
        id: 'div-gpt-ad-1629969192502-0',
    }),
    addBanner({
        slotId: '/46859844/imn.de_SERP_mobile_Header_Banner',
        id: 'div-gpt-ad-1626684808932-0',
    }),
    addNative({
        index: 1,
        slotId: '/46859844/imn.de_SERP_Desktop_Native_1',
        id: 'div-gpt-ad-1492692710095-0',
    }),
    addNative({
        index: 2,
        slotId: '/46859844/imn.de_SERP_Desktop_Native_2',
        id: 'div-gpt-ad-1701184322762-0',
    }),
    addNative({
        index: 3,
        slotId: '/46859844/imn.de_SERP_Desktop_Native_3',
        id: 'div-gpt-ad-1701184380542-0',
    }),
    addNative({
        index: 4,
        slotId: '/46859844/imn.de_SERP_Desktop_Native_4',
        id: 'div-gpt-ad-1701184439237-0',
    }),
    addNative({
        index: 5,
        slotId: '/46859844/imn.de_SERP_Desktop_Native_5',
        id: 'div-gpt-ad-1701184512423-0',
    }),
    addUnderstitial({
        slotId: '/46859844/imn.de_SERP_mobile_Understitial',
        id: 'div-gpt-ad-1489058928220-0',
    }),
];
export const mobileAdSlots = [
    addBanner({
        slotId: '/46859844/imn.de_SERP_mobile_Header_Banner',
        id: 'div-gpt-ad-1626684808932-0',
    }),
    addNative({
        index: 1,
        slotId: '/46859844/imn.de_SERP_mobile_Native_1',
        id: 'div-gpt-ad-1492692710095-0',
    }),
    addNative({
        index: 2,
        slotId: '/46859844/imn.de_SERP_mobile_Native_2',
        id: 'div-gpt-ad-1701184322762-0',
    }),
    addNative({
        index: 3,
        slotId: '/46859844/imn.de_SERP_mobile_Native_3',
        id: 'div-gpt-ad-1701184380542-0',
    }),
    addUnderstitial({
        slotId: '/46859844/imn.de_SERP_mobile_Understitial',
        id: 'div-gpt-ad-1489058928220-0',
    }),
];
